//color
export const COLOR_PRIMARY_DARK = '#363e59';
export const COLOR_PRIMARY_LIGHT = '#ebefff';
export const COLOR_INFO_LIGHT = '#363e59';
export const COLOR_SPACE_GRAY = '#6b7bb2';
export const COLOR_ERROR_TEXT = '#590400';
export const COLOR_SUCCESS = '#27AE60';
export const COLOR_WARNING = '#DA0B0B';
export const COLOR_SHALLOW_TEXT = '#999';
export const COLOR_SHALLOW_GRAY = '#666';
export const COLOR_LIGHT_RED = '#FFEBEB';

export const COLOR_REQUEST_STATUS_draft = 'gray';
export const COLOR_REQUEST_STATUS_under_consideration = 'rgb(67, 124, 216)';
export const COLOR_REQUEST_STATUS_returned_to_consumer = 'rgb(207, 125, 78)';
export const COLOR_REQUEST_STATUS_registration_started = 'rgb(206, 206, 1)';
export const COLOR_REQUEST_STATUS_done = 'rgb(55, 149, 55)';
export const COLOR_REQUEST_STATUS_canceled = 'rgb(207, 78, 78)';

export const STORAGE_KEY_TOKEN = 'token';
export const STORAGE_KEY_LOGIN = 'login';
export const TOKEN_EXPIRE_DATE = 'tokenExpires';

export const COOKIE_KEY_LOCALE = 'locale';

export const NCALYER_ERROR_STORAGE_EMPTY = 'storage.empty';
export const NCALYER_ERROR_ACTION_CANCELED = 'action.canceled';
export const NCALYER_NOT_CONNECTED = 'notConnected';

export const MAX_AVAILABLE_INTEGER = 2147483647;

export const AXIOS_ERROR_INTERCEPTED = 'intercepted';
